// Helper function to get emoji icon for custom category based on keywords
export function getCategoryEmoji(categoryName: string): string {
  const name = categoryName.toLowerCase();
  
  // Keyword-based mapping
  const emojiMap: Record<string, string> = {
    'bio': '🌱',
    'vegan': '🌱',
    'vegetarisch': '🥗',
    'gluten': '🌾',
    'laktose': '🥛',
    'halal': '☪️',
    'kosher': '✡️',
    'regional': '🏡',
    'sonder': '⭐',
    'angebot': '🏷️',
    'rabatt': '💰',
    'sale': '🔥',
    'neu': '✨',
    'saison': '🍂',
    'winter': '❄️',
    'sommer': '☀️',
    'herbst': '🍁',
    'frühling': '🌸',
    'kühl': '❄️',
    'kühlung': '❄️',
    'kühlregal': '❄️',
    'tiefkühl': '🧊',
    'gefrier': '🧊',
    'getränk': '🥤',
    'süß': '🍬',
    'süßigkeit': '🍬',
    'haushalt': '🧺',
    'asiatisch': '🥢',
    'italienisch': '🍝',
    'mexikanisch': '🌮',
    'amerikanisch': '🍔',
    'französisch': '🥐',
    'griechisch': '🫒',
    'türkisch': '🥙',
    'indisch': '🍛',
    'japanisch': '🍱',
    'chinesisch': '🥡',
    'thai': '🌶️',
    'baby': '👶',
    'kinder': '🧒',
    'pet': '🐾',
    'tier': '🐾',
    'katze': '🐱',
    'hund': '🐕',
    'vogel': '🦜',
    'fisch': '🐠',
    'party': '🎉',
    'fest': '🎊',
    'weihnacht': '🎄',
    'ostern': '🐰',
    'halloween': '🎃',
    'geburtstag': '🎂',
    'grill': '🔥',
    'picknick': '🧺',
    'camping': '⛺',
    'sport': '⚽',
    'fitness': '💪',
    'wellness': '🧘',
    'brot': '🥖',
    'käse': '🧀',
    'wurst': '🌭',
    'pasta': '🍝',
    'reis': '🍚',
    'gewürz': '🧂',
    'soße': '🥫',
    'sauce': '🥫',
    'dose': '🥫',
    'dosen': '🥫',
    'konserve': '🥫',
    'öl': '🫗',
    'essig': '🫗',
    'kräuter': '🌿',
    'tee': '🍵',
    'kaffee': '☕',
    'saft': '🧃',
    'smoothie': '🥤',
    'alkohol': '🍺',
    'wein': '🍷',
    'bier': '🍺',
    'schnaps': '🥃',
    'cocktail': '🍹',
    'kuchen': '🍰',
    'torte': '🎂',
    'keks': '🍪',
    'schoko': '🍫',
    'eis': '🍦',
    'pudding': '🍮',
    'joghurt': '🥛',
    'müsli': '🥣',
    'cerealien': '🥣',
    'nuss': '🥜',
    'mandel': '🥜',
    'samen': '🌰',
    'honig': '🍯',
    'marmelade': '🍓',
    'aufstrich': '🥜',
    'chips': '🥔',
    'knabber': '🍿',
    'popcorn': '🍿',
    'pizza': '🍕',
    'burger': '🍔',
    'pommes': '🍟',
    'nuggets': '🍗',
    'salat': '🥗',
    'gemüse': '🥬',
    'obst': '🍎',
    'beeren': '🫐',
    'zitrus': '🍊',
    'banane': '🍌',
    'apfel': '🍎',
    'birne': '🍐',
    'traube': '🍇',
    'melone': '🍉',
    'ananas': '🍍',
    'mango': '🥭',
    'avocado': '🥑',
    'tomate': '🍅',
    'gurke': '🥒',
    'paprika': '🫑',
    'karotte': '🥕',
    'möhre': '🥕',
    'kartoffel': '🥔',
    'zwiebel': '🧅',
    'knoblauch': '🧄',
    'pilz': '🍄',
    'bohne': '🫘',
    'erbse': '🫛',
    'mais': '🌽',
    'brokkoli': '🥦',
    'blumen': '💐',
    'pflanzen': '🪴',
    'garten': '🌻',
    'werkzeug': '🔧',
    'technik': '🔌',
    'elektronik': '📱',
    'büro': '📎',
    'schreib': '✏️',
    'spiel': '🎮',
    'buch': '📚',
    'musik': '🎵',
    'film': '🎬',
    'kleidung': '👕',
    'mode': '👗',
    'schmuck': '💍',
    'kosmetik': '💄',
    'parfum': '🌸',
    'hygiene': '🧼',
    'reinig': '🧹',
    'wasch': '🧺',
    'putzen': '🧽',
    'müll': '🗑️',
    'recycling': '♻️',
    'batterie': '🔋',
    'lampe': '💡',
    'kerze': '🕯️'
  };
  
  // Check keywords
  for (const [keyword, emoji] of Object.entries(emojiMap)) {
    if (name.includes(keyword)) {
      return emoji;
    }
  }
  
  // Default fallback
  return '🏷️';
}
